import { createContext, useContext, type ReactNode } from 'react';

export interface ConfirmOptions {
    title: ReactNode;
    message: ReactNode;
    /** Below the message paragraph — a list, an Alert (see ConfirmDialog). */
    details?: ReactNode;
    confirmLabel?: ReactNode;
    cancelLabel?: ReactNode;
    confirmColor?: 'error' | 'primary';
}

export type ConfirmContextType = {
    /**
     * Ask a yes/no question from code that is not a component — an export in
     * the middle of its run, say. Resolves true on confirm, false on cancel.
     */
    confirm: (options: ConfirmOptions) => Promise<boolean>;
};

// Without a provider nothing can be asked, so nothing is refused either.
export const ConfirmContext = createContext<ConfirmContextType>({
    confirm: () => Promise.resolve(true)
});

export function useConfirm() {
    return useContext(ConfirmContext);
}
